import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import Style from "./VideosSection.module.css";
import axios from "axios";
import { useQuery } from "react-query";
import { BallTriangle } from "react-loader-spinner";
import { toast } from "react-toastify";

const VideosSection = (props) => {
  const [loading, setloading] = useState(false);
  const [courseData, setCourseData] = useState(null);
  const [phonewhats, setphoneWhats] = useState(null);
  const [phonetele, setphonetele] = useState(null);
  const notify = (mess, type) => {
    toast[type](mess);
  };
  let { name, courseId, subjectId, subjectname } = useParams();
  function getvideos() {
    return axios.get(
      `https://itc-541ea27f6158.herokuapp.com/api/v1/subject-video/subject/${subjectId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      }
    );
  }
  let { isFetching, isLoading, isError, data } = useQuery(
    "featuredVideos",
    getvideos,
    {
      cacheTime: 100,
    }
  );

  function Subscriptions() {
    return axios
      .post(
        `https://itc-541ea27f6158.herokuapp.com/api/v1/subscription/${courseId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      )
      .then((response) => {
        notify("تم أرسال طلبك للمسؤول", "warn");
        // return response.data; // Assuming response.data contains subscription data
      })
      .catch((error) => {
        // Handle error
        notify(error.response.data.message, "error");
        console.error("Error fetching subscription data:", error);
        throw error; // Propagate the error for the caller to handle
      });
  }
  let navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true);
        const response = await axios.get(
          `https://itc-541ea27f6158.herokuapp.com/api/v1/course/${courseId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setloading(false);
        setCourseData(response?.data.data);
      } catch (error) {
        setloading(false);
        if (error.response.status === 405) {
          setloading(false);
          navigate("/login");
          notify(error.response.data.message, "success");
        }
        console.error("Error fetching course data:", error);
        // Handle error
      }
    };
    const getPhone = async () => {
      try {
        setloading(true);
        const response = await axios.get(
          `https://itc-541ea27f6158.herokuapp.com/api/v1/technical-support/phone-number`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setloading(false);
        setphoneWhats(response?.data?.data.whatsapp);
        setphonetele(response?.data?.data.telegram);
      } catch (error) {
        if (error.response.status == 400) {
        }

        console.error("Error fetching course data:", error);
        // Handle error
      }
    };
    getPhone();

    fetchData();
  }, []);
  return (
    <>
      <Helmet>
        <title>الفيديوهات</title>
      </Helmet>

      {isLoading && loading ? (
        <>
          <div className={`${Style.home2} w-full flex justify-center`}>
            <BallTriangle
              height={100}
              width={100}
              radius={5}
              color="#4fa94d"
              ariaLabel="ball-triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </>
      ) : (
        <>
          <div
            className={`${Style.home} bg-gray-100 min-h-screen     rounded-tr-3xl    `}
          >
            <div
              className={`${Style.Font} flex items-center bg-white p-5 rounded-xl my-5`}
            >
              <div className="flex items-center">
                <Link to={"/"} className="mr-2 text-green-500">
                  {name}
                </Link>
              </div>
              <div className="flex items-end pt-1">
                <span className="px-1 max-md:px-0.5">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                      fill="#009539"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
              </div>
              <Link
                to={`/${name}/${courseId}/subjects`}
                className="font-bold text-green-600"
              >
                {subjectname}
              </Link>
              <div className="flex items-end pt-1">
                <span className="px-1 max-md:px-0.5">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                      fill="#009539"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
              </div>
              <Link
                to={`/${name}/${courseId}/${subjectname}/${subjectId}/Videos`}
                className="font-bold text-green-600"
              >
                الفيديوهات
              </Link>
            </div>

            <div
              className={`  grid  gap-3 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2  sm:grid-cols-2 `}
            >
              {data?.data.data.map((video) => {
                return (
                  <>
                    <div key={video.videoId}>
                      <Link
                        to={`/My_subscriptions/${name}/${courseId}/VideoDetails/${video.videoId}`}
                        className={`block  p-4 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 `}
                      >
                        <div className="flex items-center justify-between pt-0">
                          <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 ">
                            {video?.videoTitle}
                          </h5>
                          {courseData?.isFree ? (
                            <>
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_265_561)">
                                  <path
                                    d="M29.0625 24.375C29.0625 26.9531 26.9531 29.0625 24.375 29.0625H5.625C3.04688 29.0625 0.9375 26.9531 0.9375 24.375V5.625C0.9375 3.04688 3.04688 0.9375 5.625 0.9375H24.375C26.9531 0.9375 29.0625 3.04688 29.0625 5.625V24.375Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M15.9375 19.2188H19.6875V17.8125H17.2969V15.7031H19.6875V14.2969H17.2969V12.1875H19.6875V10.7812H15.9375V19.2188ZM25.3125 12.1875V10.7812H21.5625V19.2188H25.3125V17.8125H22.9219V15.7031H25.3125V14.2969H22.9219V12.1875H25.3125ZM11.2031 19.2188V15.7031H11.7188L12.8906 19.2188H14.2969L13.0781 15.5156C13.9219 15.1406 14.5312 14.25 14.5312 13.2188C14.5312 11.8594 13.5 10.7812 12.1875 10.7812H9.84375V19.2188H11.2031ZM11.2031 12.1875H12.1875C12.75 12.1875 13.1719 12.6563 13.1719 13.2188C13.1719 13.7813 12.7031 14.25 12.1875 14.25H11.2031V12.1875ZM6.04687 19.2188V15.7031H8.4375V14.2969H6.04687V12.1875H8.4375V10.7812H4.6875V19.2188H6.04687Z"
                                    fill="#009539"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_265_561">
                                    <rect width="30" height="30" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </>
                          ) : (
                            <>
                              {courseData?.isSubscribed ? (
                                <>
                                  <i className="fa-solid fa-unlock fa-md text-customGreen"></i>
                                </>
                              ) : (
                                <>
                                  <i className="fa-solid fa-lock fa-md text-customGreen"></i>
                                </>
                              )}
                            </>
                          )}
                        </div>

                        <h5 className="text-lg tracking-tight text-green-500 overflow-hidden whitespace-nowrap truncate">
                          {video?.videoDescription.slice(0, 40)}
                        </h5>
                        <div className="flex items-center justify-between pt-0">
                          <div></div>
                          <svg
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12.0688 6.06C14.3739 5.8448 16.6863 5.73379 19 5.72727C21.3813 5.72727 23.7323 5.86091 25.9312 6.06C28.576 6.3 30.2885 6.46364 31.5957 6.79636C32.7864 7.09909 33.4527 7.5 34.0252 8.13C34.086 8.19818 34.1772 8.30182 34.2329 8.37545C34.7396 9.00273 35.0689 9.78818 35.2589 11.2718C35.4616 12.8618 35.4667 14.9345 35.4667 18.0682C35.4667 21.1636 35.4616 23.2091 35.2589 24.7773C35.0715 26.2391 34.7421 27.0164 34.2329 27.6518C34.1649 27.7357 34.0948 27.8175 34.0227 27.8973C33.44 28.5355 32.7813 28.9309 31.6211 29.2255C30.3367 29.5527 28.6621 29.7109 26.0629 29.9455C23.8615 30.1418 21.4725 30.2727 19 30.2727C16.5275 30.2727 14.136 30.1418 11.9371 29.9455C9.33787 29.7109 7.66333 29.5527 6.37893 29.2255C5.21613 28.9309 4.55747 28.5355 3.97733 27.8973C3.90523 27.8175 3.83512 27.7356 3.76707 27.6518C3.2604 27.0164 2.93107 26.2391 2.74107 24.7773C2.5384 23.2091 2.53333 21.1636 2.53333 18.0682C2.53333 14.9345 2.5384 12.8591 2.74107 11.2718C2.93107 9.78818 3.2604 9.00273 3.76707 8.37545C3.82533 8.30182 3.914 8.19818 3.9748 8.13C4.54733 7.5 5.2136 7.09909 6.40427 6.79636C7.714 6.46364 9.424 6.3 12.0688 6.06ZM0 18.0682C0 11.9536 0 8.89636 1.84933 6.59182C1.94053 6.47727 2.06467 6.33273 2.16347 6.22364C4.13947 4.04455 6.71333 3.81 11.856 3.34364C14.1107 3.13636 16.5351 3 19 3C21.4649 3 23.8893 3.13636 26.144 3.34364C31.2867 3.81 33.8605 4.04455 35.8365 6.22364C35.9353 6.33273 36.0569 6.47727 36.1507 6.59182C38 8.89636 38 11.9536 38 18.0682C38 24.1091 38 27.1309 36.1481 29.4355C36.0458 29.5614 35.9402 29.6842 35.8315 29.8036C33.8529 31.9827 31.3272 32.2091 26.2732 32.6618C24.016 32.8664 21.5536 33 19 33C16.4464 33 13.984 32.8636 11.7293 32.6618C6.6728 32.2091 4.14707 31.98 2.16853 29.8036C2.05983 29.6841 1.95424 29.5613 1.85187 29.4355C0 27.1309 0 24.1091 0 18.0682ZM13.3 12.2264C13.2996 12.113 13.3256 12.0012 13.3754 11.9013C13.4253 11.8014 13.4975 11.7165 13.5855 11.6542C13.6736 11.5919 13.7746 11.5542 13.8796 11.5446C13.9846 11.535 14.0901 11.5537 14.1867 11.5991L26.4176 17.3755C26.9243 17.6155 26.9243 18.3845 26.4176 18.6245L14.1867 24.3982C14.0903 24.4435 13.985 24.4622 13.8802 24.4527C13.7755 24.4432 13.6746 24.4058 13.5866 24.3438C13.4986 24.2819 13.4263 24.1973 13.3763 24.0977C13.3263 23.9982 13.3001 23.8868 13.3 23.7736V12.2264Z"
                              fill="#01943A"
                            />
                          </svg>
                        </div>
                      </Link>
                    </div>
                  </>
                );
              })}
            </div>
            {courseData?.isFree ||
            courseData?.isSubscribed ||
            courseData?.subscriptionStatus == "PENDING" ? (
              <></>
            ) : (
              <>
                <div className="bg-white max-md:w-7/12 max-sm:w-12/12 text-center p-5 w-6/12 m-auto max-sm:w-10/12  rounded-xl mt-10">
                  <button
                    onClick={() =>
                      document.getElementById("my_modal_2").showModal()
                    }
                    className="bg-yellowCustom btn-ghost max-md:px-20 max-md:text-md  max-md:py-4 max-sm:px-16 max-sm:py-4 max-sm:text-lg   hover:bg-yellow-400 text-white p-5 px-24 text-3xl rounded-xl"
                  >
                    اشترك الأن
                  </button>
                  <dialog id="my_modal_2" className="modal">
                    <div className="modal-box">
                      <h3 className="font-bold text-lg mb-4">
                        {" "}
                        قم بتأكيد الطلب ثم تواصل مع المسؤول
                      </h3>
                      {phonewhats || phonetele ? (
                        <>
                          <div
                            className={`grid grid-cols-1 ${Style.wwww} w-8/12 mx-auto `}
                          >
                            <Link
                              to={`https://wa.me/+2${phonewhats}`}
                              className="btn mb-2 hover:border-customGreen  bg-white  border-customGreen"
                            >
                              <h3 className={`text-lg ${Style.font_wha} `}>
                                {phonewhats}
                              </h3>
                              <svg
                                className={Style.svgs}
                                width="29"
                                height="29"
                                viewBox="0 0 35 35"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g filter="url(#filter0_d_110_458)">
                                  <path
                                    d="M3.61863 14.3742C3.61795 16.8188 4.25958 19.2058 5.47962 21.3098L3.50195 28.4983L10.8915 26.5694C12.9354 27.6771 15.2254 28.2575 17.5525 28.2577H17.5586C25.2407 28.2577 31.4942 22.0344 31.4975 14.3851C31.499 10.6785 30.0503 7.19304 27.4183 4.57077C24.7868 1.94873 21.287 0.503958 17.558 0.502266C9.87493 0.502266 3.62192 6.72524 3.61875 14.3742"
                                    fill="url(#paint0_linear_110_458)"
                                  />
                                  <path
                                    d="M3.12121 14.3695C3.12042 16.9021 3.78504 19.3745 5.04858 21.5537L3 29L10.6545 27.0019C12.7636 28.1467 15.1382 28.7503 17.5545 28.7512H17.5607C25.5185 28.7512 31.9966 22.304 32 14.381C32.0014 10.5412 30.5006 6.93042 27.7746 4.21421C25.0483 1.49834 21.4233 0.00157886 17.5607 0C9.60158 0 3.12438 6.44627 3.12121 14.3695ZM7.67965 21.1784L7.39384 20.7268C6.19238 18.8249 5.55823 16.6271 5.55914 14.3704C5.56174 7.78481 10.9453 2.42694 17.5653 2.42694C20.7711 2.42829 23.7839 3.67244 26.05 5.92976C28.316 8.18731 29.5629 11.1883 29.5621 14.3801C29.5591 20.9656 24.1754 26.3242 17.5607 26.3242H17.556C15.4021 26.323 13.2898 25.7472 11.4476 24.659L11.0092 24.4002L6.46686 25.5858L7.67965 21.1783V21.1784Z"
                                    fill="url(#paint1_linear_110_458)"
                                  />
                                  <path
                                    d="M13.9527 8.3625C13.6824 7.76445 13.398 7.75238 13.1409 7.74189C12.9304 7.73287 12.6898 7.73355 12.4495 7.73355C12.2088 7.73355 11.8179 7.82366 11.4875 8.18285C11.1567 8.54238 10.2246 9.4112 10.2246 11.1783C10.2246 12.9455 11.5175 14.6533 11.6977 14.8931C11.8782 15.1326 14.1936 18.8749 17.8608 20.3146C20.9085 21.511 21.5287 21.2731 22.1902 21.2131C22.8517 21.1533 24.3248 20.3445 24.6254 19.5058C24.9261 18.6672 24.9261 17.9483 24.836 17.7981C24.7458 17.6485 24.5052 17.5586 24.1444 17.379C23.7835 17.1994 22.0097 16.3305 21.679 16.2106C21.3483 16.0908 21.1078 16.031 20.8672 16.3907C20.6265 16.7498 19.9356 17.5586 19.7251 17.7981C19.5147 18.0382 19.3041 18.0681 18.9434 17.8885C18.5824 17.7082 17.4205 17.3294 16.0419 16.1059C14.9694 15.1539 14.2453 13.9782 14.0348 13.6185C13.8243 13.2595 14.0123 13.0648 14.1932 12.8858C14.3553 12.7249 14.5541 12.4664 14.7347 12.2568C14.9146 12.047 14.9746 11.8973 15.0949 11.6578C15.2153 11.4181 15.1551 11.2083 15.065 11.0286C14.9746 10.849 14.2735 9.07265 13.9527 8.3625Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <filter
                                    id="filter0_d_110_458"
                                    x="0"
                                    y="0"
                                    width="35"
                                    height="35"
                                    filterUnits="userSpaceOnUse"
                                    colorInterpolationFilters="sRGB"
                                  >
                                    <feFlood
                                      floodOpacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                      in="SourceAlpha"
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                      result="hardAlpha"
                                    />
                                    <feOffset dy="3" />
                                    <feGaussianBlur stdDeviation="1.5" />
                                    <feComposite
                                      in2="hardAlpha"
                                      operator="out"
                                    />
                                    <feColorMatrix
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in2="BackgroundImageFix"
                                      result="effect1_dropShadow_110_458"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in="SourceGraphic"
                                      in2="effect1_dropShadow_110_458"
                                      result="shape"
                                    />
                                  </filter>
                                  <linearGradient
                                    id="paint0_linear_110_458"
                                    x1="1403.28"
                                    y1="2800.11"
                                    x2="1403.28"
                                    y2="0.502266"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#1FAF38" />
                                    <stop offset="1" stopColor="#60D669" />
                                  </linearGradient>
                                  <linearGradient
                                    id="paint1_linear_110_458"
                                    x1="1453"
                                    y1="2900"
                                    x2="1453"
                                    y2="0"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#F9F9F9" />
                                    <stop offset="1" stopColor="white" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </Link>
                            <Link
                              to={phonetele}
                              className="btn hover:border-customGreen  bg-white  border-customGreen"
                            >
                              <h3 className={`text-lg ${Style.font_wha} `}>
                                {phonetele}
                              </h3>
                              <svg
                                className={Style.svgs}
                                width="29"
                                height="29"
                                viewBox="0 0 29 29"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_441_26)">
                                  <path
                                    d="M14.5 0C10.6552 0 6.96453 1.52862 4.24805 4.24691C1.52876 6.96629 0.000753252 10.6543 0 14.5C0 18.3441 1.5293 22.0348 4.24805 24.7531C6.96453 27.4714 10.6552 29 14.5 29C18.3448 29 22.0355 27.4714 24.752 24.7531C27.4707 22.0348 29 18.3441 29 14.5C29 10.6559 27.4707 6.96521 24.752 4.24691C22.0355 1.52862 18.3448 0 14.5 0Z"
                                    fill="url(#paint0_linear_441_26)"
                                  />
                                  <path
                                    d="M6.56279 14.347C10.7904 12.5055 13.6089 11.2914 15.0181 10.7048C19.0464 9.02985 19.8824 8.73895 20.4284 8.72909C20.5485 8.72716 20.8158 8.75684 20.9903 8.89788C21.1353 9.01682 21.1761 9.17768 21.1965 9.29063C21.2146 9.40345 21.2395 9.6606 21.2191 9.86134C21.0016 12.1541 20.0568 17.7181 19.5765 20.2862C19.3749 21.3728 18.9739 21.7371 18.5865 21.7726C17.7436 21.8501 17.1047 21.2162 16.2891 20.6817C15.0136 19.845 14.2931 19.3244 13.0538 18.5081C11.6219 17.5647 12.5508 17.0461 13.3665 16.1987C13.5794 15.9769 17.2905 12.6023 17.3608 12.2962C17.3698 12.2579 17.3789 12.1152 17.2928 12.04C17.209 11.9645 17.0843 11.9903 16.9937 12.0107C16.8646 12.0397 14.8278 13.3873 10.8765 16.0533C10.2988 16.4507 9.77544 16.6444 9.30419 16.6342C8.78763 16.6231 7.79076 16.3415 7.0499 16.1009C6.14365 15.8057 5.42091 15.6496 5.48435 15.1482C5.51607 14.8872 5.8763 14.6201 6.56279 14.347Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_441_26"
                                    x1="1450"
                                    y1="0"
                                    x2="1450"
                                    y2="2900"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#2AABEE" />
                                    <stop offset="1" stopColor="#229ED9" />
                                  </linearGradient>
                                  <clipPath id="clip0_441_26">
                                    <rect width="29" height="29" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </Link>
                          </div>
                        </>
                      ) : (
                        <>
                          <Link className="btn hover:border-customGreen w-8/12 bg-white  border-customGreen">
                            <h3 className="text-2xl">لا يوجد رقم تواصل الان</h3>
                          </Link>
                        </>
                      )}

                      <div className="modal-action">
                        <form method="dialog" className="mx-auto">
                          {/* if there is a button in form, it will close the modal */}
                          <button
                            onClick={Subscriptions}
                            className="py-2.5 px-5  text-sm font-medium text-white  bg-customGreen rounded-lg border border-gray-200 hover:bg-green-700   "
                          >
                            تأكيد الطلب
                          </button>
                          <button className="text-white ms-3 bg-red-600 hover:bg-red-800  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                            الغاء الطلب
                          </button>
                        </form>
                      </div>
                    </div>
                  </dialog>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default VideosSection;
